import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/App.css';
import Todo from './components/Todo/Todo';

function App() {
  return (
    <div className="App">
      <Todo />
    </div>
  );
}

export default App;
